import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "folder-tree w-56 bg-slate-50/50 border-r border-slate-200/60 flex flex-col shrink-0"
};
const _hoisted_2 = {
  class: "tree-header px-3 py-2.5 border-b border-slate-200/60 flex items-center justify-between shrink-0 bg-white"
};
const _hoisted_3 = {
  class: "tree-body flex-1 overflow-y-auto py-1.5 bg-slate-50/50"
};
const _hoisted_4 = {
  key: 0,
  class: "px-3 py-10 text-center"
};
import { Plus, Folder } from '@element-plus/icons-vue';
import FolderTreeNode from './FolderTreeNode.vue';
export default {
  __name: 'AssetFolderTree',
  props: {
    treeData: {
      type: Array,
      default: () => []
    },
    selectedId: {
      type: [Number, String],
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select', 'edit', 'delete', 'move', 'acl', 'refresh', 'create-root'],
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[7] || (_cache[7] = _createElementVNode("span", {
        class: "text-xs font-semibold text-slate-600 tracking-wide"
      }, "文件夹", -1)), _createElementVNode("button", {
        type: "button",
        class: "btn-icon",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('create-root')),
        title: "新建根文件夹"
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Plus))]),
        _: 1
      })])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [__props.treeData.length === 0 && !__props.loading ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_icon, {
        size: 32,
        class: "text-slate-300 mb-2 block"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Folder))]),
        _: 1
      }), _cache[8] || (_cache[8] = _createElementVNode("p", {
        class: "empty-state-title"
      }, "暂无文件夹", -1)), _cache[9] || (_cache[9] = _createElementVNode("p", {
        class: "text-[10px] text-slate-300 mt-1"
      }, "点击上方 + 新建", -1))])) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(__props.treeData, node => {
        return _openBlock(), _createBlock(FolderTreeNode, {
          key: node.id,
          node: node,
          "selected-id": __props.selectedId,
          depth: 0,
          onSelect: _cache[1] || (_cache[1] = $event => _ctx.$emit('select', $event)),
          onEdit: _cache[2] || (_cache[2] = $event => _ctx.$emit('edit', $event)),
          onDelete: _cache[3] || (_cache[3] = $event => _ctx.$emit('delete', $event)),
          onMove: _cache[4] || (_cache[4] = $event => _ctx.$emit('move', $event)),
          onAcl: _cache[5] || (_cache[5] = $event => _ctx.$emit('acl', $event)),
          onRefresh: _cache[6] || (_cache[6] = $event => _ctx.$emit('refresh'))
        }, null, 8, ["node", "selected-id"]);
      }), 128))])), [[_directive_loading, __props.loading]])]);
    };
  }
};